<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'une Société
      </span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <company-form @submit="submit" :loading="loading"></company-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CompanyForm from '@/components/company/CompanyForm'

  export default {
    name: 'CompanyCreate',
    data () {
      return {
        loading: false,
        route: this.$route
      }
    },
    components: {
      CompanyForm
    },
    methods: {
      submit (company) {
        this.loading = true
        this.$api.companyService.post(company).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'La Société a bien été créée'
          })
          this.$router.push({name: 'CompanyVue', params: {id: res.data.pk}})
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout de la société.'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyCreate.vue